import styled from 'styled-components';

import { BaseButton } from '@/ui/Button/type/default/styles/button';
import { Icon } from '@/ui/Icon';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/DropdownMenu';
import { PageVariant } from '@/features/course/admin/types/page';

const ActionItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

interface CourseDrawerAddActivityButtonProps {
  onAddClick: (type: PageVariant) => void;
}

export const CourseDrawerAddActivityButton = ({ onAddClick }: CourseDrawerAddActivityButtonProps): JSX.Element => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <BaseButton type="button" variant="neutral">
        <Icon icon="plus" size="lg" />
      </BaseButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent variant="subtle" side="bottom" align="end">
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.PAGE)}>
        <ActionItemStyled>
          <Icon icon={['far', 'rectangle']} />
          Page
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.REFLECTION)}>
        <ActionItemStyled>
          <Icon icon={['far', 'comment-pen']} />
          Reflection
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.QUIZ)}>
        <ActionItemStyled>
          <Icon icon={['far', 'game-board-simple']} />
          Quiz
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.ASSIGNMENT)}>
        <ActionItemStyled>
          <Icon icon={['far', 'pen-line']} />
          Assignment
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.MODULE)}>
        <ActionItemStyled>
          <Icon icon={['far', 'rectangle-history']} />
          Module
        </ActionItemStyled>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
